import Croppa from 'vue-croppa';
import { TWO } from '../../constants';

export default class ImagePositionHandler {
  croppa!: typeof Croppa.component;

  constructor(croppa: typeof Croppa.component) {
    this.croppa = croppa;
  }

  toTop() {
    this.croppa.imgData.startY = 0;
  }

  toBottom() {
    this.croppa.imgData.startY = -(this.croppa.imgData.height - this.croppa.outputHeight);
  }

  toLeft() {
    this.croppa.imgData.startX = 0;
  }

  toRight() {
    this.croppa.imgData.startX = -(this.croppa.imgData.width - this.croppa.outputWidth);
  }

  toCenter() {
    this.croppa.imgData.startX = -(this.croppa.imgData.width - this.croppa.outputWidth) / TWO;
    this.croppa.imgData.startY = -(this.croppa.imgData.height - this.croppa.outputHeight) / TWO;
  }

  containImage({ startX, startY }: { startX?: number; startY?: number } = {}) {
    const imgWidth = this.croppa.naturalWidth;
    const imgHeight = this.croppa.naturalHeight;
    const canvasRatio = this.croppa.outputWidth / this.croppa.outputHeight;
    let scaleRatio;
    let metadata;
    if (this.croppa.aspectRatio > canvasRatio) {
      scaleRatio = imgWidth / this.croppa.outputWidth;
      this.croppa.imgData.height = imgHeight / scaleRatio;
      this.croppa.imgData.width = this.croppa.outputWidth;

      metadata = {
        startX: 0,
        startY: startY !== undefined ? startY : -(this.croppa.imgData.height - this.croppa.outputHeight) / TWO,
        scale: this.croppa.outputWidth / imgWidth,
        orientation: 1
      };
    } else {
      scaleRatio = imgHeight / this.croppa.outputHeight;
      this.croppa.imgData.width = imgWidth / scaleRatio;
      this.croppa.imgData.height = this.croppa.outputHeight;

      metadata = {
        startX: startX !== undefined ? startX : -(this.croppa.imgData.width - this.croppa.outputWidth) / TWO,
        startY: 0,
        scale: this.croppa.outputHeight / imgHeight,
        orientation: 1
      };
    }
    this.croppa.applyMetadata(metadata);
  }
}
